<template lang="pug">
.re-test-version-watermark
  span {{ $t("тестовая_версия") }}
</template>

<script>
export default {
}
</script>

<style scoped>
.re-test-version-watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.re-test-version-watermark span {
  transform: rotate(-30deg);
  font-size: 42px;
  font-weight: 900;
  letter-spacing: 6px;
  white-space: nowrap;
  color: var(--v-error-base);
  opacity: 0.5;
  user-select: none;
}
</style>
